import { useState, useEffect } from "react";
import { Dropdown, Modal, Nav, Tab, Tabs } from "react-bootstrap";
import Button from "@mui/material/Button";

const CustomPopupModal = ({
    popupBody,
    popupFooterButtonLabel,
    popupFooterButtonClick,
    popupFooterButtonStatus,
}) => {
    const [openPopupModal, setOpenPopupModal] = useState(true);
    return (
        <Modal show={openPopupModal} className="unsaved-changes-modal">
            {/* <Modal.Header>
                <Modal.Title>Upload</Modal.Title>
            </Modal.Header> */}
            <Modal.Body>
                {/* <h3 className="unsaved-changes-message">Changing tabs will loose all unsaved changes. <span>Are you sure?</span></h3> */}
                {popupBody}
            </Modal.Body>
            <div className="popupFooter">
                <div className="popupFooterSeparator"></div>
                {/* <Button
                    className="btn popupFooterGrayedButton"
                    type="button"
                    // onClick={() => proceedCodeEditorHandler('cancel')}
                >
                    CANCEL
                </Button> */}
                <Button
                    className="btn popupFooterActiveButton"
                    type="button"
                    onClick={popupFooterButtonClick}
                    disabled={!popupFooterButtonStatus}
                >
                    {popupFooterButtonLabel}
                </Button>
            </div>
        </Modal>
    )
}

export default CustomPopupModal;